<template>
  <div>
    <el-dialog
      @close="handleDialogCancel"
      :visible.sync="setTagVisible"
      title="图片打标签"
    >
      <div>
        <Tag
          ref="editTag"
          :isOpt="false"
          @handleTagClick="(value) => handleTagClick(value)"
        />
      </div>
      <div style="text-align: center">
        <el-button size="small" @click="sureTagImg">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看图片" :visible.sync="imgDetailsShow" width="90%">
      <div class="show-img-wrap">
        <img
          style="max-width: 500px; margin-right: 10px"
          :src="item"
          :key="index"
          v-for="(item, index) in detailsImgs"
        />
      </div>
    </el-dialog>
    <el-dialog
      @close="handleDialogCancel"
      title="上传图片"
      :visible.sync="visible"
    >
      <div>
        <Tag
          ref="tag"
          :isOpt="false"
          @handleTagClick="(value) => handleTagClick(value)"
        />
      </div>
      <div style="margin-top: 10px">
        <div class="my-upload-wrap">
          <span class="upload-text">{{ uploadText }}</span>
          <input
            class="upload-input"
            type="file"
            name="folder"
            multiple
            webkitdirectory
            @change="changFolder"
          />
        </div>
        <div v-if="isProgress" class="upload-tip">
          上传中....<span class="progress">{{ progressNumber }}%</span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogCancel">取 消</el-button>
        <el-button type="primary" @click="startUpload" :loading="isProgress"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>图片列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="padding: 5px 0px">
      <el-button size="small" type="primary" @click="showDialog"
        >上传图片</el-button
      >
      <el-button
        style="float: right; margin-right: 20px"
        size="small"
        type="danger"
        @click="deleteImg(selectImgs.map((item) => item.id))"
        >批量删除</el-button
      >
      <el-button
        style="float: right; margin-right: 20px"
        size="small"
        type="primary"
        @click="clickToAddTags"
        >批量打标签</el-button
      >
    </div>

    <LoadingNoDialog :loading="loading">
      <el-table
        @selection-change="handleSelectionChange"
        class="clear-fix"
        border
        :empty-text="emptyText"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="url" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.url" style="height: 100px" />
            <img
              :key="key"
              v-for="(item, key) in scope.row.otherUrls"
              :src="item.url"
              style="height: 100px"
            />
          </template>
        </el-table-column>
        <el-table-column min-width="80" prop="mytags" label="标签">
          <template slot-scope="scope">
            <span
              :key="key"
              v-for="(item, key) in scope.row.mytags"
              style="height: 100px"
            >
              <div style="font-size: 16px">
                {{ item.oneName }}
              </div>
              <div
                :key="index"
                v-for="(each, index) in item.children"
                style="margin: 10px 0px"
              >
                <span style="color: red">{{ each.towName }}：</span>
                <el-tag
                  style="margin: 0px 5px"
                  :key="id"
                  v-for="(it, id) in each.threeName"
                  type="primary'"
                  disable-transitions
                  >{{ it }}</el-tag
                >
              </div>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="名称" prop="name"> </el-table-column>

        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>

        <el-table-column label="操作" width="185">
          <template slot-scope="scope">
            <el-button
              @click="deleteImg([scope.row.id])"
              type="danger"
              size="small"
              >删除</el-button
            >
            <el-button
              style="margin-left: 10px"
              @click="showImgDetails(scope.row)"
              type="primary"
              size="small"
              >查看图片</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 10px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </LoadingNoDialog>
  </div>
</template>

<script>
import OssUpload from "../../common/OssUpload";
import UploadFileUtils from "./UploadFileUtils";
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import Tag from "./Tag.vue";
import Img from "../../components/Img.vue";

export default {
  name: "Role",
  data() {
    return {
      imgDetailsShow: false, //查看详情
      visible: false,
      emptyText: "暂无数据",
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      selectTagIds: [],
      files: [],
      uploadText: "上传图片",
      totalProgress: 0,
      progressIng: 0,
      progressNumber: 0,
      isProgress: false,
      selectImgs: [],
      detailsImgs: [], //显示的图片
      setTagVisible: false,
    };
  },
  components: {
    LoadingNoDialog,
    Tag,
    Img,
  },
  mounted() {
    this.getList();
    //this.sortByName();
  },
  methods: {
    sortByName(arra) {
      // arra = [
      //   {
      //     id: 0,
      //     name: "2122秋冬Bronx女鞋靴子品牌精选_6a2fd3db-7adf-4e67-86b9-c2a811c1fdd0.jpg",
      //   },
      //   {
      //     id: 1,
      //     name: "1_2122秋冬Bronx女鞋靴子品牌精选_2c9d5824-f83a-48fe-aece-692c740375b2.jpg",
      //   },
      //   {
      //     id: 1,
      //     name: "2122秋冬Bronx女鞋靴子品牌精选_2c9d5824-f83a-48fe-aece-692c740375b2.jpg",
      //   },
      // ];

      let res = arra.sort((item1, item2) => {
        let item1Arras = item1.name.split("_");
        let i1 = -1;
        if (item1Arras.length > 1) {
          try {
            i1 = parseInt(item1Arras[0]);
          } catch (e) {}
        }
        let item2Arras = item2.name.split("_");

        let i2 = -1;
        if (item2Arras.length > 1) {
          try {
            i2 = parseInt(item2Arras[0]);
          } catch (e) {}
        }

        return i1 <= i2 ? 1 : -1;
      });
      console.info(res);

      return res;
      // console => arr = ['美国', '日本', '中国']
    },
    handleSelectionChange(val) {
      this.selectImgs = val;
    },
    async deleteImg(imgIds) {
      this.$confirm("是否确认删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let r = await axios.delete("/admin/img/deletes", {
          data: { imgIds: imgIds },
        });
        if (r.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        } else {
          this.$message({
            type: "fail",
            message: "删除失败!",
          });
        }
      });
    },
    handleDialogCancel() {
      if (this.isProgress) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    showDialog() {
      this.uploadText = "上传图片";
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.tag.clearnTag();
      });
    },
    async uploadSuccess(response, row) {
      let url = response.data.url;
      let r = await axios.post("/admin/user/update", {
        payCode: url,
        userId: row.id,
      });
      const that = this;
      that.getList();
    },
    async handleClick(row) {},

    //选中标签
    handleTagClick(tagIds) {
      console.info(tagIds);
      console.info("tagids....");
      this.selectTagIds = tagIds;
    },
    //changFolder
    changFolder(e) {
      e.target.valule = "";
      let files = e.target.files;
      let uploadFileUtils = new UploadFileUtils();

      console.info(files);

      let fileObj = uploadFileUtils.checkImgDir(files);
      this.totalProgress = fileObj.files.length;
      this.uploadText = `已选${fileObj.files.length}张图片`;
      this.files = files;
    },
    //上传文件夹
    async startUpload() {
      this.isProgress = true;
      let files = this.files;
      let uploadFileUtils = new UploadFileUtils();
      let checkResult = uploadFileUtils.checkImgDir(files);
      if (checkResult.flag === false) {
        this.$message.warning("上传的文件夹目录为一级或者三级，请检查");
        return;
      }

      let files2 = checkResult.files.filter((item) => item.length == 2);
      let files3 = checkResult.files.filter((item) => item.length == 3);
      let clearnRepeatFiles = Array.from(
        new Set(files3.map((item) => item.webkitRelativePath.split("/")[1]))
      );
      files3 = clearnRepeatFiles.map((item) =>
        files3.filter((each) => each.webkitRelativePath.indexOf(item) > -1)
      );
      files = uploadFileUtils.resetFilesSort(checkResult.files, files3);
      files = this.sortByName(files);
      let results = [];
      for (let file of files) {
        console.info(file.name);
        let otherResults = [];
        if (file.otherFiles) {
          for (let fileOther of file.otherFiles) {
            let suffix = uploadFileUtils.getSuffix(fileOther.name);
            let r = await this.uploadImg(fileOther, suffix, fileOther.name);
            otherResults.push({ key: r.objectKey, name: fileOther.name });
          }
        } else {
          let suffix = uploadFileUtils.getSuffix(file.name);
          let r = await this.uploadImg(file, suffix, file.name);
          otherResults.push({ key: r.objectKey, name: file.name });
        }
        this.progressIng = this.progressIng + otherResults.length;
        this.progressNumber = this.progressIng / this.totalProgress;
        //Math.floor()this.progressNumber*100
        this.progressNumber = Math.round(this.progressNumber * 100 * 100) / 100;

        //todo 上传到后台保存
        results.push(otherResults);
        //results.concat(otherResults)
        //results=[...results,...otherResults]
      }
      function getParentTags(tags, selectTags) {
        let parentTags = [];
        for (let oTag of tags) {
          for (let tTag of oTag.tags) {
            for (let threeTag of tTag.tags) {
              let isIncludeTag = selectTags.includes(threeTag.id);
              if (isIncludeTag) {
                parentTags.push(oTag.id);
                parentTags.push(tTag.id);
              }
            }
          }
        }
        parentTags = Array.from(new Set(parentTags));
        return parentTags;
      }
      let rtags = getParentTags(this.$store.state.tags, this.selectTagIds);

      let r = await axios.post("/admin/add/imgs", {
        imgs: results,
        tagIds: this.selectTagIds,
        parentTagIds: rtags,
      });

      if (r.code == 0) {
        this.visible = false;
        this.$message.success("上传成功");
        this.isProgress = false;
        this.getList();
      } else {
        this.$message.warning("不完全上传成功");
      }
    },
    async uploadImg(file, suffix, fileName) {
      let ossUpload = new OssUpload();
      let ossResult = await ossUpload.uploadFileForFileStream(
        file,
        1,
        suffix,
        fileName
      );
      return ossResult;
    },
    async getList() {
      this.loading = true;
      let r = await axios.get("/admin/img/lists", {
        params: { page: this.page, size: this.size },
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.tableData = r.data.rows.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );
      this.tableData = this.tableData.map((item) =>
        Object.assign(item, {
          payCode: item.payCode + `?t=${Date.parse(new Date())}`,
          wallet: item.totalSum - item.remainSum,
        })
      );
      this.total = r.data.count;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showImgDetails(item) {
      this.imgDetailsShow = true;
      this.detailsImgs = [];
      this.detailsImgs.push(item.url);
      if (item.otherUrls.length > 0) {
        this.detailsImgs = [
          ...this.detailsImgs,
          ...item.otherUrls.map((item) => item.url),
        ];
      }
    },
    clickToAddTags() {
      if (this.selectImgs.length == 0) {
        this.$message.warning("请选择图片");
        return;
      }
      this.selectTagIds = [];
      this.setTagVisible = true;
      this.$nextTick(() => {
        this.$refs.editTag.clearnTag();
      });
    },
    async sureTagImg() {
      if (this.selectTagIds.length == 0) {
        this.$message.warning("请选择标签");
        return;
      }

      console.info(this.selectTagIds);
      function getParentTags(tags, selectTags) {
        let parentTags = [];
        for (let oTag of tags) {
          for (let tTag of oTag.tags) {
            for (let threeTag of tTag.tags) {
              let isIncludeTag = selectTags.includes(threeTag.id);
              if (isIncludeTag) {
                parentTags.push(oTag.id);
                parentTags.push(tTag.id);
              }
            }
          }
        }
        parentTags = Array.from(new Set(parentTags));
        return parentTags;
      }
      let rtags = getParentTags(this.$store.state.tags, this.selectTagIds);
      let r = await axios.post("/admin/tag/add/img", {
        tagIds: [...this.selectTagIds, ...rtags],
        imgIds: this.selectImgs.map((item) => item.id),
      });
      this.setTagVisible = false;
      this.selectTagIds = [];
      this.tagIds = [];
      this.getList();
    },
  },
};
</script>
<style scope>
.my-upload-wrap {
  display: inline-block;
  border-radius: 3px;
  background: #409eff;
  position: relative;
  height: 30px;
  width: 80px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.upload-input {
  opacity: 0;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 80px;
  height: 30px;
  cursor: pointer;
}

.upload-text {
  cursor: pointer;
  color: white;
}
.upload-tip {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
}
.progress {
  font-size: 12px;
  color: red;
  margin-left: 10px;
}
.show-img-wrap {
  display: flex;
  justify-content: center;
}
</style>




// WEBPACK FOOTER //
// src/main/admin/ImgList.vue